// Web variant of useSocialAuth.
//
// The native hook (useSocialAuth.ts) statically imports the native-only SDKs
// `@react-native-firebase/auth`, `@react-native-google-signin/google-signin`
// and `@invertase/react-native-apple-authentication`, none of which ship a
// react-native-web build — so pulling them into the Vite/esbuild web bundle
// breaks the build. Mirroring the `useFcm.ts` / `useFcm.web.ts` split, this
// `.web.ts` variant is resolved by vite-plugin-react-native-web for the web
// target and keeps the bundle free of those native modules.
//
// Social sign-in is not wired on web yet: the handlers are inert no-ops so the
// auth screen still renders and the primary email/password flow works.
type SocialAuthHook = {
  signInWithGoogle: () => Promise<void>
  signInWithApple: () => Promise<void>
  signInWithFacebook: () => Promise<void>
  signInWithLinkedIn: () => Promise<void>
}

const noop = async (): Promise<void> => {}

export const useSocialAuth = (): SocialAuthHook => {
  return {
    signInWithGoogle: noop,
    signInWithApple: noop,
    signInWithFacebook: noop,
    signInWithLinkedIn: noop,
  }
}
